import { useTranslation } from 'react-i18next'
import {
  Alert,
  AlertProps,
  AlertTitle,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText
} from '@mui/material'

export type ValveAttachInRuuviTagToHeaterInstructionsAlertProps = Omit<AlertProps, 'children'>

export default function ValveAttachInRuuviTagToHeaterInstructionsAlert({
  ...props
}: ValveAttachInRuuviTagToHeaterInstructionsAlertProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('valve')

  return (
    <Alert severity="info" {...props}>
      <AlertTitle sx={{ mt: 0 }}>
        {t('ValveAttachInRuuviTagToHeaterInstructionsAlert.title')}
      </AlertTitle>

      <List>
        <ListItem sx={{ py: 1 }}>
          <ListItemAvatar sx={{ minWidth: 16 }}>1.</ListItemAvatar>
          <ListItemText primary={t('ValveAttachInRuuviTagToHeaterInstructionsAlert.stepOne')} />
        </ListItem>
        <ListItem sx={{ py: 1 }}>
          <ListItemAvatar sx={{ minWidth: 16 }}>2.</ListItemAvatar>
          <ListItemText primary={t('ValveAttachInRuuviTagToHeaterInstructionsAlert.stepTwo')} />
        </ListItem>
        <ListItem sx={{ py: 1 }}>
          <ListItemAvatar sx={{ minWidth: 16 }}>3.</ListItemAvatar>
          <ListItemText primary={t('ValveAttachInRuuviTagToHeaterInstructionsAlert.stepThree')} />
        </ListItem>
      </List>
    </Alert>
  )
}
